<div style="display: inline-block; width: 100%;">
    <h2 style="float: left; margin: auto 0;">Test Output</h2>

    <button [routerLink]="['/reserved', 'contracts', contractId, 'test-list']" matTooltip="Show test list" style="float: right;  margin: auto 0;" mat-button>
        <!-- <mat-icon>list</mat-icon> -->
        Open Test List
    </button>
    <div *ngIf="selectedForReport.size > 0" style="margin-bottom: 15px; text-align: right;">
    <button (click)="generateConsolidatedReport()" 
            mat-raised-button 
            color="primary" 
            matTooltip="Generate report for selected tests">
        <mat-icon>assessment</mat-icon>
        Generate Report ({{selectedForReport.size}})
    </button>
</div>
<ng-template #loadingGeneral>
    <mat-spinner class="center"></mat-spinner>
    <p class="center">Loading...</p>
  </ng-template>
<div *ngIf="errorMessage" class="error-message">
    {{ errorMessage }}
</div>
  <div *ngIf="!isForbidden" style="width: 100%; height: auto; text-align: right;">
    <button mat-button [matMenuTriggerFor]="menu"> <mat-icon>apps</mat-icon> Status <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon></button>
    <mat-menu #menu="matMenu">
        <div *ngFor="let b of box_status">
        <button mat-menu-item (click) = "showBoxInfo(b)">
            {{b.identifier}} <mat-icon [ngStyle]="{'color': b.isOnline ? 'green' : 'red'}" iconPositionEnd>brightness_1</mat-icon>
        </button>
        </div>
<!--         <button mat-menu-item>
            Wseth - 2 <mat-icon [ngStyle]="{'color': 'red'}" iconPositionEnd>brightness_1</mat-icon>
        </button> -->
    </mat-menu>
</div>

  <ng-container *ngIf="!loading else loadingGeneral">    
<ng-template *ngIf="dataSource === null || dataSource.results.length === 0 ; then True else False" />
<ng-template #True>
    <h4 *ngIf="!errorMessage">No output available!</h4>
</ng-template>
<ng-template #False>
    <table mat-table [dataSource]="dataSource.results" class="mat-elevation-z8">
    
        <!-- <ng-container matColumnDef="testId">
            <th mat-header-cell *matHeaderCellDef>testId</th>
            <td mat-cell *matCellDef="let element"> {{element.testId}} </td>
        </ng-container> -->
        <ng-container matColumnDef="Report">
            <th mat-header-cell *matHeaderCellDef>Report</th>
            <td mat-cell *matCellDef="let element">
                <mat-checkbox 
                    *ngIf="element.exec_status === 'completed'"
                    [checked]="isSelectedForReport(element.id_run)"
                    [disabled]="!isSelectedForReport(element.id_run) && hasAnySelectedForReport()"
                    (change)="onReportChange(element, $event.checked)"
                    matTooltip="Select for report generation">
                </mat-checkbox>
            </td>
            <!-- [disabled] è una soluzione temporanea per evitare che si possano selezionare più di un test per volta, da rimuovere quando si abiliterà il report multiplo -->
        </ng-container>
        <ng-container matColumnDef="User">
            <th mat-header-cell *matHeaderCellDef>User</th>
            <td mat-cell *matCellDef="let element">
            <img [src]="getProfileImage(element.user)" matTooltip="{{ element.user_name + ' ' + element.user_surname }}" style="border-radius: 50%; border: 2px black solid;">
            </td>
        </ng-container>
    
        <ng-container matColumnDef="Testname">
            <th mat-header-cell *matHeaderCellDef>Testname</th>
            <td mat-cell *matCellDef="let element"> {{element.test_name}}</td>
        </ng-container>

        <ng-container matColumnDef="Box">
            <th mat-header-cell *matHeaderCellDef>Box</th>
            <td mat-cell *matCellDef="let element"> {{element.box}}</td>
        </ng-container>

        <ng-container matColumnDef="Interface">
            <th mat-header-cell *matHeaderCellDef>Interface</th>
            <td mat-cell *matCellDef="let element"> {{element.box_interface}}</td>
        </ng-container>
    
        <ng-container matColumnDef="Created at">
            <th mat-header-cell *matHeaderCellDef>Created</th>
            <td mat-cell *matCellDef="let element"> {{element.created_at | date: 'medium'}} </td>
        </ng-container>
    
        <ng-container matColumnDef="Completed at">
            <th mat-header-cell *matHeaderCellDef>Completed</th>
            <td mat-cell *matCellDef="let element"> {{element.completed_at | date: 'medium'}} </td>
        </ng-container>
        
    
        <ng-container matColumnDef="Execution Status">
            <th mat-header-cell *matHeaderCellDef>Execution Status</th>
            <td mat-cell *matCellDef="let element"> 
                <ng-container *ngIf="element.exec_status == 'scheduled'"> 
                    <mat-icon aria-hidden="true" matTooltip="Scheduled" fontIcon="schedule" [ngStyle]="{'color': 'grey'}"></mat-icon>  
                </ng-container>
                <ng-container *ngIf="element.exec_status == 'completed'"> 
                    <mat-icon aria-hidden="true" matTooltip="Completed" fontIcon="check" [ngStyle]="{'color': 'green'}"></mat-icon>  
                </ng-container>
                <ng-container *ngIf="element.exec_status == 'preprocessing'"> 
                    <mat-icon aria-hidden="true" matTooltip="Setting up the environment" fontIcon="cloud_sync" [ngStyle]="{'color': '#ffdd00'}"></mat-icon>  
                </ng-container>
                <ng-container *ngIf="element.exec_status == 'running'"> 
                    <mat-icon aria-hidden="true" matTooltip="Running" fontIcon="directions_run"></mat-icon>  
                </ng-container> 
                <ng-container *ngIf="element.exec_status == 'postprocessing'"> 
                    <mat-icon aria-hidden="true" matTooltip="Preparing the output file" fontIcon="receipt_long" [ngStyle]="{'color': '#ffdd00'}"></mat-icon>  
                </ng-container>    
                <ng-container *ngIf="element.exec_status == 'fail'"> 
                    <mat-icon aria-hidden="true" matTooltip="Fail" fontIcon="close" [ngStyle]="{'color': 'red'}"></mat-icon>  
                </ng-container>
                <ng-container *ngIf="element.exec_status == 'stopped'"> 
                    <mat-icon aria-hidden="true" matTooltip="Stopped" fontIcon="dangerous" [ngStyle]="{'color': 'red'}"></mat-icon>  
                </ng-container>        
            </td>
        </ng-container>
        <ng-container matColumnDef="Result">
        <th mat-header-cell *matHeaderCellDef>Result</th>
        <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.exec_status === 'completed'">
            <ng-container *ngIf="element.test_outcome === 'green'">
                <mat-icon 
                matTooltip="Passed" 
                [ngStyle]="{'color': 'green'}">brightness_1</mat-icon>
                
            </ng-container>
            <ng-container *ngIf="element.test_outcome === 'red'">
                <mat-icon 
                matTooltip="Failed" 
                [ngStyle]="{'color': 'red'}">brightness_1</mat-icon> 
                
            </ng-container>
            <ng-container *ngIf="element.test_outcome === 'yellow'">
                <mat-icon 
                matTooltip="Warning" 
                [ngStyle]="{'color': 'yellow'}">brightness_1</mat-icon> 
                
            </ng-container>
            <ng-container *ngIf="!element.test_outcome || (element.test_outcome !== 'green' && element.test_outcome !== 'red' && element.test_outcome !== 'yellow')">
                <mat-icon 
                matTooltip="Unknown" 
                [ngStyle]="{'color': 'grey'}">brightness_1</mat-icon>
            </ng-container>
            
        </ng-container>
        <ng-container *ngIf="element.exec_status !== 'completed'">
            <mat-icon 
            matTooltip="Pending" 
            [ngStyle]="{'color': 'lightgray'}">brightness_1</mat-icon>
            
        </ng-container>
    </td>
    </ng-container>
    
        <ng-container matColumnDef="output">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element"> 
                <ng-container *ngIf="element.exec_status === 'completed'"> 
                    <div class="vertical-flow">
                        <button (click)="viewOutput(element)" matTooltip="See Output" mat-icon-button>
                            <mat-icon fontIcon="remove_red_eye"></mat-icon>
                        </button>
                        <button (click)="downloadOutput(element.id_run)" matTooltip="Download Output" mat-icon-button>
                            <mat-icon fontIcon="file_download"></mat-icon>
                        </button>
                    </div>  
                </ng-container>
                <ng-container *ngIf="element.exec_status === 'running'">
                    <button (click) = "deleteTestInExecution(element.id_run)" [matTooltip]=" element.user === loggedUser.email 
                            ? 'Forced Stop test' 
                            : 'You cannot stop the test since you are not the owner '" [disabled] = "element.user !== loggedUser.email" mat-icon-button>
                        <mat-icon fontIcon="stop"></mat-icon>
                    </button>
                </ng-container>
            </td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    
    </table>

    <mat-paginator #paginator
               class="demo-paginator"
               (page)="handlePageEvent($event)"
               [length]="length"
               [pageSize]="pageSize"
               [hidePageSize]="true"
               [pageIndex]="pageIndexRequest - 1"
               [disabled]="disablePaginator"
               aria-label="Select page">
        </mat-paginator>
</ng-template>

  </ng-container>